import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { ContentRoute, Layout } from "../_layout/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./auth";
import { PaginaErro404 } from "./pages/PaginaErro404";
import { ProblemasConta } from "./pages/ProblemasConta";

export function Routes() {
  const { isAuthorized } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.user != null
    }),
    shallowEqual
  );

  return (
    <Switch>
      <Route path="/problemas-conta" component={ProblemasConta} />
      <Route path="/error" component={PaginaErro404} />

      {!isAuthorized ? (
        <Route>
          <AuthPage />
        </Route>
      ) : (
        <Redirect from="/auth" to="/" />
      )}
      <Route path="/logout" component={Logout} />
      <Layout>
        <BasePage />
      </Layout>
      {!isAuthorized ? (
        <Redirect to="/auth/login" />
      ) : (
        <Layout>
          <BasePage />
        </Layout>
      )}
    </Switch>
  );
}
